
/* Myka Home — Enhanced Predictive Search */
(function() {
  var searchInput = null;
  var resultsContainer = null;
  var debounceTimer = null;
  var currentQuery = '';

  function init() {
    // Find all search inputs
    var inputs = document.querySelectorAll('input[type="search"], input[name="q"], .search-input input, .halo-header-search input');
    inputs.forEach(function(input) {
      if (!input.dataset.mhEnhanced) {
        input.dataset.mhEnhanced = '1';
        input.addEventListener('input', function() {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function() {
            doSearch(input.value.trim());
          }, 200);
        });
      }
    });
  }

  function doSearch(query) {
    if (!query || query.length < 2) return;
    if (query === currentQuery) return;
    currentQuery = query;

    // Call Shopify Predictive Search API
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,tag,variants.sku';

    fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        console.log('[MH Search] "' + query + '" → ' + products.length + ' results');
      })
      .catch(function(e) {
        console.log('[MH Search] Error:', e);
      });
  }

  // Re-init after dynamic content loads
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  setTimeout(init, 1000);
})();


// === Myka Home Critical CSS Fix - 2026-07-20 ===
// Injected via search-enhance.js to bypass theme CDN cache
(function(){
  if (document.getElementById('myka-critical-fixes')) return;
  var style = document.createElement('style');
  style.id = 'myka-critical-fixes';
  style.textContent = 'body:not(.template-index) .header-classic,body:not(.template-index) .header-classic .header-navigation{background:#000!important}body:not(.template-index) .header-classic .site-nav,body:not(.template-index) .header-classic .menu-lv-1__action,body:not(.template-index) .header-classic .header__icon,body:not(.template-index) .header-classic .header__icon svg{color:#fff!important;fill:#fff!important}.header-classic .menu-dropdown .site-nav-banner-item--right{max-width:240px!important;flex:0 0 240px!important;overflow:hidden!important}.header-classic .menu-dropdown .site-nav-banner-item--right .adaptive_height{max-height:200px!important;overflow:hidden!important}.header-classic .menu-dropdown .site-nav-banner-item--right .adaptive_height img{width:100%!important;height:100%!important;max-height:200px!important;object-fit:cover!important;display:block!important}.menu-dropdown.megamenu_style_1{max-height:500px!important;overflow-y:auto!important}.megamenu_style_1 .col-left{min-width:0!important;flex:1 1 auto!important}.megamenu_style_1 .col-right{flex:0 0 auto!important;max-width:240px!important}';
  document.head.appendChild(style);
})();
